import * as React from 'react'

import type { Field } from 'factorial-form'
import keys from 'lodash/keys'

import { observer } from 'mobx-react'

import CheckControl from 'modules/core/components/Inputs/CheckControl'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import DateRange from 'modules/timeoff/components/DateRange'
import type Leave from 'modules/timeoff/store/models/Leave'

import styles from './index.module.css'

export interface RelapseOption {
  leave: Leave
  field: Field
  year: number
  name: string
  value: string | undefined
  employeeTimeoffPolicyId: string | null | undefined
}

const RelapseItem: React.FC<RelapseOption> = ({
  leave,
  field,
  year,
  name,
  value,
  employeeTimeoffPolicyId,
}) => {
  const getYears = (): string => {
    const startOn = stringToDate(leave.attributes.start_on, 'backend')
    const finishOn = stringToDate(leave.attributes.start_on, 'backend')

    if (startOn.isSame(finishOn, 'year')) {
      return startOn.format('YYYY')
    }

    return `${startOn.format('YYYY')}/${finishOn.format('YYYY')}`
  }

  const getNumberOfDays = (): string => {
    const accruesList = leave.attributes.accrues_list
    const count = accruesList[year] || 0
    const yearsKeys = keys(accruesList)

    if (yearsKeys.length <= 1) {
      return `${count} ${i18n.tp('common.day', { count })}`
    }

    return `${count} ${i18n.tp('time_off.count_leave_days_current_year', { count, year })}`
  }

  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <DateRange leave={leave} employeeTimeoffPolicyId={employeeTimeoffPolicyId} />
        <div className={styles.contentInner}>
          <div className={styles.title}>
            {leave.leaveType?.name}
            <span className={styles.days}>
              {getYears()} - {getNumberOfDays()}
            </span>
          </div>
        </div>
      </div>
      <CheckControl field={field} value={value} name={name} skin="checkbox" />
    </div>
  )
}

export default observer(RelapseItem)
